// Validation for incoming chat responses against the strict JSON contract.
// See docs/CHAT-JSON-CONTRACT.md.
//
// SECURITY NOTE: this is the gate at the boundary — responses that fail
// validation are rejected before they can reach the renderer. Rendering
// safety itself comes from `MessageBlocks.vue` using Vue's `{{ }}`
// interpolation (auto-escaped), not from this validation. A `text` block
// whose `value` contains `<script>` is a VALID response — it just gets
// rendered as literal characters by the renderer, not as a script tag.

export const KNOWN_BLOCK_TYPES = new Set(['text', 'notice']);

const BLOCKS_WITH_STRING_VALUE = new Set(['text', 'notice']);

export function isValidResponse(json) {
  if (!json || typeof json !== 'object' || !Array.isArray(json.blocks)) { return false; }
  return json.blocks.every(isValidBlock);
}

export function isValidBlock(b) {
  if (!b || typeof b !== 'object' || !KNOWN_BLOCK_TYPES.has(b.type)) { return false; }
  if (BLOCKS_WITH_STRING_VALUE.has(b.type) && typeof b.value !== 'string') { return false; }
  return true;
}
